<template>
    <div>
        <div
            class="faq-category-name"
            :class="{ 'active': isActive }"
            @click.prevent.stop="showDropdown()"
            v-if="name"
        >
            <div
                class="faq-category-dropdown-overlay"
                :class="{ 'active' : isActive }"
            ></div>

            <div
                class="faq-category-dropdown rounded-t-xl rounded-b-xl"
                :class="{ 'active' : isActive }"
            >
                <div class="flex items-center px-4 w-full h-16 bg-hh-grey-100 rounded-t-2xl">{{ name }}</div>

                <div
                    class="flex items-center px-4 w-full h-16 border-t last:rounded-b-xl"
                    v-for="category in categoryData ?? []"
                    v-show="category.name !== name"
                    @click.prevent.stop="activateCategory(category)"
                >{{ category.name }}</div>

            </div>

            {{ name }}
        </div>

        <faq-question
            v-for="(question, index) in this.questions"
            :key="index"
            :ref="question + '_' + index"
            :category-ref="categoryRef"
            :question-data="question"
        ></faq-question>
    </div>
</template>

<script>

import FaqQuestion from './FaqQuestion.vue';

export default {

    name: "FaqCategory",

    components: {
        'faq-question': FaqQuestion,
    },

    props: ['categoryData', 'questionData', 'categoryRef', 'categoryName'],

    data() {
        return {
            isActive: false,
            categories: [],
            questions: [],
        }
    },

    created() {
        this.questions = this.questionData;
        this.name = this.categoryName ? this.categoryName : null;
    },

    mounted() {
        this.Bus.on('close-all-faq-categories-' + this.categoryRef, this.map);
        // this.Bus.on('show-faq-menu', this.showFaqMenu);
        //
    },

    methods: {

        map() {
            this.Bus.emit('close-all-faq-questions-' + this.categoryRef);
        },

        activateCategory(category) {
            this.isActive = false;
            this.Bus.emit('activate-category', category);
        },

        showDropdown() {

            this.isActive = ! this.isActive;


            //
            //
            // window.scrollTo({ top: 0, behavior: "instant" });
            //
            // let body = document.getElementsByTagName('body')[0];
            // body.classList.add('with-faq-menu');
            //
            // //LOL SO IMPORTANT!!!!!!!!!!!! CRITICAL SYSTEM FUNCTIONALITY
            //
            // let header = document.querySelector('.header-content');
            // header.classList.remove('undocked');
            // header.classList.add('docked');
            // header.classList.add('shadow');
        }
    }
}
</script>
